import React, { Component } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';

function withParams(Component) {
  return (props) => {
    const params = useParams();
    return <Component {...props} params={params} />;
  };
}

class RulesView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ruleName: '',
      description: '',
      ruleComponents: [],
      logicalOperators: [],
      selectedAction: '',
      ruleEnabled: false,
    };
  }

  componentDidMount() {
    this.loadRuleForViewing();
  }

  loadRuleForViewing() {
    const { ruleId } = this.props.params;
    console.log('Received ruleId:', ruleId);

    if (!ruleId) {
      console.error('Missing ruleId parameter!');
      toast.error('Invalid Rule ID');
      return;
    }

    fetch(`/composite-backend/internal/ui/rules/get-rule?ruleName=${ruleId}`)
      .then((response) => response.json())
      .then((data) => {
        console.log('Loaded Rule Data:', data);
        if (!data.components || !Array.isArray(data.components)) {
          console.error('Invalid rule components format');
        }

        let logicalOperators = data.logicalOperators || [];
        while (logicalOperators.length < data.components.length - 1) {
          logicalOperators.push("AND");
        }

        this.setState(
          {
            ruleName: data.name || '',
            description: data.description || '',
            ruleComponents: data.components || [],
            logicalOperators: logicalOperators,
            selectedAction: data.action || '',
            ruleEnabled: data.enabled || false,
          },
          () => {
            console.log("Updated State - ruleComponents:", this.state.ruleComponents);
          }
        );
      })
      .catch((error) => {
        console.error('Error loading the rule:', error);
        toast.error('Failed to load the rule.');
      });
  }

  render() {
    const { ruleName, description, ruleComponents, logicalOperators } = this.state;

    return (
      <div style={{ padding: '24px', minHeight: '100vh', display: 'flex', flexDirection: 'column', fontFamily: 'Arial, sans-serif' }}>
        <header style={{ backgroundColor: '#007BFF', padding: '16px', color: '#FFF', textAlign: 'center' }}>
          <h2>Rules Management</h2>
        </header>

        <div style={{ flex: '1', padding: '24px' }}>
          <div style={{ display: 'flex', gap: '24px', marginBottom: '20px' }}>
            <div style={{ flex: 1 }}>
              <label><strong>Rule Name</strong></label>
              <input type="text" value={ruleName} readOnly style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #D1D5DB', fontWeight: 'bold' }} />
            </div>
            <div style={{ flex: 1 }}>
              <label><strong>Description</strong></label>
              <input type="text" value={description} readOnly style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #D1D5DB', fontWeight: 'bold' }} />
            </div>
          </div>

          <h3>Conditions</h3>
          {ruleComponents.length > 0 ? (
            ruleComponents.map((component, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                <select value={component.comparison?.object_1?.object || ''} disabled style={{ padding: '4px', width: '150px', borderRadius: '4px', border: '1px solid #D1D5DB', fontWeight: 'bold' }}>
                  <option>{component.comparison?.object_1?.object}</option>
                </select>
                <select value={component.comparison?.object_1?.attribute || ''} disabled style={{ padding: '4px', width: '200px', borderRadius: '4px', border: '1px solid #D1D5DB', fontWeight: 'bold' }}>
                  <option>{component.comparison?.object_1?.attribute}</option>
                </select>
                <select value={component.comparison?.operator || ''} disabled style={{ padding: '4px', width: '120px', borderRadius: '4px', border: '1px solid #D1D5DB', fontWeight: 'bold' }}>
                  <option>{component.comparison?.operator}</option>
                </select>
                {component.comparison?.object_2 ? (
                  <>
                    <select value={component.comparison?.object_2?.object || ''} disabled style={{ padding: '4px', width: '150px', borderRadius: '4px', border: '1px solid #D1D5DB', fontWeight: 'bold' }}>
                      <option>{component.comparison?.object_2?.object}</option>
                    </select>
                    <select value={component.comparison?.object_2?.attribute || ''} disabled style={{ padding: '4px', width: '200px', borderRadius: '4px', border: '1px solid #D1D5DB', fontWeight: 'bold' }}>
                      <option>{component.comparison?.object_2?.attribute}</option>
                    </select>
                  </>
                ) : (
                  <input type="text" value={component.comparison?.value || ''} readOnly style={{ padding: '8px', border: '1px solid #D1D5DB', borderRadius: '4px', fontWeight: 'bold' }} />
                )}
                {index < logicalOperators.length && (
                  <span style={{ marginLeft: '8px', fontWeight: 'bold' }}>{logicalOperators[index]}</span>
                )}
              </div>
            ))
          ) : (
            <p>No conditions available.</p>
          )}

          <div style={{ marginTop: '20px' }}>
            <Link to="/rules-listing" style={{ padding: '10px 16px', backgroundColor: '#007BFF', color: '#FFF', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold' }}>
              Back to Rules Listing
            </Link>
          </div>
        </div>

        <footer style={{ backgroundColor: '#007BFF', color: '#FFF', textAlign: 'center', padding: '16px', marginTop: 'auto' }}>
          <p>Idenza Rules Management © 2025</p>
        </footer>
      </div>
    );
  }
}

export default withParams(RulesView);

